import { useMemo, useState } from "react";
import type { LocalTask } from "../closeTemplateTasksDrawer.types";
import {
    getBlockedDescendantIds,
    getRelatedLocalIds,
    isTaskSavable,
} from "../closeTemplateTaskLinks";

export function useTaskLinkState(
    task: LocalTask | null,
    linkableTasks: readonly LocalTask[] | undefined,
) {
    const [blockedByLocalIds, setBlockedByLocalIds] = useState<string[]>(
        () => task?.blockedByLocalIds ?? [],
    );
    const [relatedLocalIds, setRelatedLocalIds] = useState<string[]>(() =>
        task && linkableTasks
            ? getRelatedLocalIds(task.localId, linkableTasks)
            : [],
    );

    const taskId = task?.localId;
    const options = useMemo(
        () =>
            (linkableTasks ?? [])
                .filter((t) => isTaskSavable(t) && t.localId !== taskId)
                .map((t) => ({ localId: t.localId, name: t.name })),
        [linkableTasks, taskId],
    );
    const cyclicLocalIds = useMemo(
        () =>
            taskId && linkableTasks
                ? getBlockedDescendantIds(taskId, linkableTasks)
                : new Set<string>(),
        [taskId, linkableTasks],
    );

    return {
        isEnabled: linkableTasks !== undefined,
        options,
        cyclicLocalIds,
        blockedByLocalIds,
        relatedLocalIds,
        setBlockedByLocalIds,
        setRelatedLocalIds,
    };
}
